import styled from 'styled-components'

import { Button } from '@src/components/Button'

export const ButtonContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  background-color: white;
  box-sizing: border-box;
`

export const StyledCheckoutButton = styled(Button)`
  border-radius: 28px;
  font-size: 16px;
  height: 56px;
`

export const SpaceBetweenContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 32px;
`
